import { CompanyType } from '@api';
import { t } from 'i18next';
import { z } from 'zod';

const TRANS_PATH = 'TAX_AND_DUTIES.FORM_ERRORS';

const buildTaxAndDutiesFormSchema = () =>
  z.object({
    vatRate: z
      .number({
        message: t(`companyDetailsFinance:${TRANS_PATH}.VAT_RATE_REQUIRED`),
      })
      .int(t(`companyDetailsFinance:${TRANS_PATH}.VAT_RATE_RANGE`))
      .min(0, t(`companyDetailsFinance:${TRANS_PATH}.VAT_RATE_RANGE`))
      .max(100, t(`companyDetailsFinance:${TRANS_PATH}.VAT_RATE_RANGE`)),
    isKskLiable: z.boolean(),
  });

type TaxAndDutiesFormSchemaType = ReturnType<typeof buildTaxAndDutiesFormSchema>;
export type TaxAndDutiesFormValuesType = z.infer<TaxAndDutiesFormSchemaType>;

type UseTaxAndDutiesSchemaReturnType = {
  schema: TaxAndDutiesFormSchemaType;
  defaultValues: TaxAndDutiesFormValuesType;
};

export const useTaxAndDutiesSchema = (
  company: CompanyType
): UseTaxAndDutiesSchemaReturnType => {
  const schema = buildTaxAndDutiesFormSchema();

  const defaultValues: TaxAndDutiesFormValuesType = {
    vatRate: company.vatRate,
    isKskLiable: company.isKskLiable,
  };

  return { schema, defaultValues };
};
